import * as React from 'react';
import { GameProvider } from './GameContext';
import Game, { Props } from './Game';

const WhatsTheTitle: React.FC<Props> = ({ data }) => {
  return (
    <GameProvider>
      <Game data={data} />
    </GameProvider>
  );
};

export default WhatsTheTitle;
